// functions / libraries
import React, { Fragment } from 'react';
import {Link} from 'react-router-dom';
import { __, __n } from 'i18n-for-browser';
import Defines from '../../Defines';
import connect from "react-redux/es/connect/connect";
import Scrollbar from 'react-scrollbars-custom';

import {
  getFeedback,
  getFeedbackTitle,
  getSubtitle,
  getIcon,
  getCosts,
  getCollaborations,
  getPoints,
  getImageText,
  getImage,
  getText,
  getSideEffects,
  checkRead,
  getEconomieFeedback
} from "../../helpers/feedbackHelpers";
import {getGroupIcons} from '../../helpers/groupHelper';
import actions from '../../actions';
import history from "../../history.js";

// components
import ScoreRow from '../elements/ScoreRow';
import ScoreHistory from '../elements/ScoreHistory';
import FeedbackImage from '../elements/feedback/FeedbackImage';
import FeedbackHeader from '../elements/feedback/FeedbackHeader';
import FeedbackEffect from './FeedbackEffect';
import DifficultyAwareComponent from "../DifficultyAwareComponent";

// assets
import ContentContainer from "../elements/ContentContainer";
import {ministryIcons, icons} from '../../assets/assets.js';
import FeedbackStatusRounds from "../elements/feedback/FeedbackStatusRounds";
import CaretDown from "../../assets/img/caret_down_grey.svg";
import {
  getIcon as getPolicyChoiceIcon,
  getOplossingTekst, getOplossingTitle,
  getProbleemTekst,
  getTitle
} from "../../helpers/policyChoiceHelper";
import scrollIntoView from "scroll-into-view";
import NextStep from "../elements/NextStep";

const { updateRead } = actions.feedback;

class Feedback extends DifficultyAwareComponent {
  constructor(props) {
    super(props);

    this.state = {
      flip: true,
      showEffects: false,
    };

    this.state.pageType = props.match.params.id;
    this.state.feedbackId = props.match.params.feedbackIdentifier;
    this.state.effectId = props.match.params.effect;
    this.state.oe = this.state.pageType === 'overigEffect';
    this.state.economie = this.state.pageType === 'economie';

    this.scrollToRef = null;
    this.setScrollToRef = element => {
      this.scrollToRef = element;
    }

    this.scrollTo = () => {
      if(this.scrollToRef) {
        setTimeout(() => {
          scrollIntoView(
            this.scrollToRef,
            {
              topOffset: 200,
            }
          );
        }, 500);
      }
    }
  }
  "Hey Joshua, I am working on an app to assist people with baking their own goods! The idea so far is timeboxed recipes. So for example the first step is mix and kneed the dough. When you're done you're told to store it in a bowl and store it in a warm place for half an hour. After that half hour you get a notification on your phone telling you to continue or store it in the fridge. When you continue you get the next step, slap and folds for example. I think you get the gist of it! Now I came to you to ask if you got some ideas for what I could add to the app. Looking forward to your reply!"

  static getDerivedStateFromProps(nextProps, prevState) {
    const newState = {...prevState};

    newState.pageType = nextProps.match.params.id;
    newState.feedbackId = nextProps.match.params.feedbackIdentifier;
    newState.effectId = nextProps.match.params.effect;
    newState.oe = newState.pageType === 'overigEffect';
    newState.economie = newState.pageType === 'economie';

    return newState;
  }

  componentDidMount() {
    this.scrollTo();
  }

  flipContainer = () => {
    this.setState(prevState => ({
      flip:!prevState.flip,
    }));
  };

  toggleProbleem = () => {
    this.setState(prevState => ({
      showProbleem: !prevState.showProbleem,
    }));
  };

  toggleOplossing = () => {
    this.setState(prevState => ({
      showOplossing: !prevState.showOplossing,
    }));
  };

  renderFeedbackHeader = (feedback, overigEffect, economie, hideClose = false, isEffectCollection = false) => {
    const { gameState, history } = this.props;
    let points = false;

    /**
     * Een lelijke hack om de GoBackButton van de feedback header een custom handler te geven
     * wanneer je in stap 3 zit en de situatie aan het bekijken bent.
     *
     * Wanneer je op de button klikt, moet je weer in het verdelen gedeelte komen van de ministerie.
     */
    let closeButtonHandler = null;
    if (this.props.gameState.currentStep === 3 && this.props.location.pathname.startsWith('/ministries') && this.props.match.params.feedbackIdentifier && this.props.match.params.id) {
      closeButtonHandler = this.props.history.goBack;
    }
    // EO ugly hack

    if (this.state.oe) {
      points = overigEffect.puntenscore;
    } else if (this.state.economie) {
      points = economie.winstverliesglobas;
    } else if (feedback) {
      points = getPoints(feedback, gameState, getCollaborations(feedback, this.props.gameStateInput).length);
    }
    if ((this.state.pageType === 'beleidskeuze' && gameState.difficulty === 'BASIC') || (feedback.titel_oplossing_NL && gameState.difficulty === 'BASIC')) {
      let title;
      if (feedback.oplossing_code) {
        title = getOplossingTitle(feedback, gameState.language);
      } else {
        title = getTitle(feedback, gameState.language);
      }

      return <FeedbackHeader
        closeButtonHandler={closeButtonHandler}
        key="header"
        currentRound={gameState.currentRound}
        history={history}
        type={title}
        icon={getPolicyChoiceIcon(feedback)}
        prependEffect={gameState.difficulty === 'BASIC' && (feedback.type !== 'BELEIDSKEUZE' || isEffectCollection === true) ? true : null}
        points={gameState.difficulty === 'BASIC' && (feedback.type !== 'BELEIDSKEUZE' || isEffectCollection === true) ? feedback.economie.winstverliesglobas : feedback.puntenscore}
        miljard={gameState.difficulty === 'BASIC' && (feedback.type !== 'BELEIDSKEUZE' || isEffectCollection === true) ? true : false}
        hideClose={hideClose}
        niveau={gameState.difficulty}
      />;
    }

    if (getFeedbackTitle(feedback, gameState.language)) {
      if (gameState.difficulty === 'BASIC') {
        if(isEffectCollection === true) {
          return <FeedbackHeader
            closeButtonHandler={closeButtonHandler}
            key="header"
            currentRound={gameState.currentRound}
            history={history}
            noTitle={false}
            type={(feedback.type === "BELASTING" ? getFeedbackTitle(feedback, gameState.language) : feedback.ministerie)}
            prependEffect={gameState.difficulty === 'BASIC' ? true : null}
            points={economie.winstverliesglobas}
            miljard={true}
            icon={(feedback.type === "BELASTING" ? getIcon(feedback) : ministryIcons[feedback.ministerie])}
            niveau={gameState.difficulty}
            hideClose={hideClose}
          />;
        }
        return <FeedbackHeader
          closeButtonHandler={closeButtonHandler}
          key="header"
          currentRound={gameState.currentRound}
          history={history}
          noTitle={true}
          prependEffect={gameState.difficulty === 'BASIC' ? true : null}
          popUpTitle={Defines.ministryPopupIds.basic[feedback.ministerie]}
          icon={ministryIcons[feedback.ministerie]}
          niveau={gameState.difficulty}
          hideClose={hideClose}
        />;
      }
    }

    if (feedback) {
      return <FeedbackHeader
        closeButtonHandler={closeButtonHandler}
        key="header"
        currentRound={gameState.currentRound}
        history={history}
        type={getFeedbackTitle(feedback)}
        subtitle={getSubtitle(feedback, gameState.language)}
        icon={getIcon(feedback)}
        prependEffect={gameState.difficulty === 'BASIC' ? true : null}
        disaster={feedback.type === 'RAMP'}
        points={gameState.difficulty === 'BASIC' ? feedback.economie.winstverliesglobas : points}
        miljard={this.state.economie || gameState.difficulty === 'BASIC'}
        hideClose={hideClose}
        niveau={gameState.difficulty}
      />;
      }
    return null;
  }

  renderStatistics = (feedback, overigEffect, economie) => {
    const { gameState, gameStateInput, schoolClass } = this.props;
    if (this.state.pageType === 'beleidskeuze' && gameState.difficulty === 'BASIC') {
      return (
        <span className={'low-dropdown-wrapper'}>
          <ContentContainer outerClassName={`${(this.state.showProbleem ? ' show' : '')}`} className="problem-solution-container standardAnimation">
            <div className="top-bar" onClick={this.toggleProbleem}>
              <h3>{__('sim_feedback_wat_is_het_probleem')}</h3>
              <img src={CaretDown} alt={'close'} className={'close-status' + (this.state.showProbleem ? ' rotate' : '')}/>
            </div>
            <div className={`inner${(this.state.showProbleem ? ' show' : '')}`}>
              <div className="inner-content">
                <h4>{__('sim_probleem')}</h4>
                <p>{getProbleemTekst(feedback, gameState.language)}</p>
              </div>
            </div>
          </ContentContainer>
          <ContentContainer outerClassName={`${(this.state.showOplossing ? ' show' : '')}`} className="problem-solution-container standardAnimation">
            <div className="top-bar" onClick={this.toggleOplossing}>
              <h3>{__('sim_feedback_wat_is_jullie_oplossing')}</h3>
              <img src={CaretDown} alt={'close'} className={'close-status' + (this.state.showOplossing ? ' rotate' : '')}/>
            </div>
            <div className={`inner${(this.state.showOplossing ? ' show' : '')}`}>
              <div className="inner-content">
                <h4>{__('sim_oplossing')}</h4>
                <p>{getOplossingTekst(feedback, gameState.language)}</p>
              </div>
              <div className="inner-content">
                <h4>{__('sim_kosten')}:</h4>
                <span>{`${feedback.kosten_globas || 0} ${__('sim_miljard')}`}</span>
              </div>
            </div>
          </ContentContainer>
        </span>
      );
    }

    if (!this.state.oe && !this.state.economie && feedback) {
      if (feedback.type === 'STARTSITUATIE') return null;
      if (['ALGEMEEN', 'RAMP'].indexOf(feedback.type) !== -1) {
        const groupIcons = getGroupIcons(getCollaborations(feedback, gameStateInput), schoolClass.Groups);
        return (
          <div className={"flip-container " + (this.state.flip ? '' : 'flip')}>
              <div className="flipper">
                <div className="front">
                  <ScoreRow
                    text={__('sim_kosten')}
                    score={`${getCosts(feedback, gameState)} ${__('sim_miljard')}`}
                  />
                  {Defines.i18nMinistries.includes(feedback.ministerie) ? (
                    groupIcons.length ? (
                      <ScoreRow
                        className="align-right"
                        text={__('sim_samenwerking')}
                        imgs={groupIcons}
                      />
                    ) : (
                      <ScoreRow
                        className="no-collaborations"
                        text={__('sim_samenwerking')}
                        score="-"
                      />
                    )
                  ) : null}
                  <ScoreRow
                    text={__n('sim_score', 1)}
                    score={`${getPoints(feedback, gameState, getCollaborations(feedback, gameStateInput).length)} ${__('sim_punten').toLowerCase()}`}
                  />
                  {gameState.difficulty === "PRO" ?
                    <ScoreRow
                      text={__('sim_neveneffecten')}
                      score={feedback.nevenEffecten || 0}
                    />
                      :
                    null
                  }
                  <button onClick={this.flipContainer}><span>{__('sim_bekijkhistorie')}</span></button>
                </div>
                <div className="back">
                  {gameState.Rounds.map((r,i) => <ScoreHistory key={i} round={i} ministerie={feedback.ministerie}/>)}
                  <button onClick={this.flipContainer}><span>{__('sim_terug')}</span></button>
                </div>
              </div>
            </div>
        );
      }
      return (
        <div key="card" className="card-container">
          <ContentContainer className={'standardAnimation'}>
            <ScoreRow
              text={__('sim_kosten')}
              score={`${getCosts(feedback, gameState)} ${__('sim_miljard')}`}
            />
            {feedback.type === 'BELEIDSKEUZE' && feedback.omschrijving.match(/SW(\d){1,2}$/i) ? (
              <ScoreRow
                className="align-right"
                text={__('sim_samenwerking')}
                imgs={getGroupIcons(getCollaborations(feedback, gameStateInput), schoolClass.Groups)}
              />
            ) : null}
            <ScoreRow
              text={__n('sim_score', 1)}
              score={`${getPoints(feedback, gameState, getCollaborations(feedback, gameStateInput).length)} ${__('sim_punten').toLowerCase()}`}
            />
            <ScoreRow
              text={__('sim_neveneffecten')}
              score={feedback.nevenEffecten || 0}
            />
          </ContentContainer>
        </div>
      );
    }
    return null;
  }

  renderFeedbackImage = (feedback, overigEffect, economie, forceEconomy = false) => {
    const { gameState } = this.props;
    let text = getImageText(feedback, gameState.language);
    let img = getImage(feedback);
    if (this.state.oe) {
      text = getImageText(overigEffect, gameState.language);
      img = getImage(overigEffect, feedback);
    }

    if(feedback.niveau.toLowerCase() === 'basic'){
      if (this.state.economie || forceEconomy) {
        if (feedback.type === 'BELEIDSKEUZE') {
          text = getImageText(feedback.economie, gameState.language);
          img = getImage(feedback.economie);
        } else {
          text = getImageText(economie, gameState.language);
          img = getImage(economie);
        }
      } else if (feedback.type === 'BELEIDSKEUZE') {
        img = feedback.img_2;
      }
    } else {
      if(this.state.economie && economie) {
        text = getImageText(economie, gameState.language);
        img = getImage(economie, feedback);
      }
    }

    return (
      <FeedbackImage
        disaster={feedback.type === 'RAMP'}
        description={text}
        image={img}
        desktop={true}
        forceShowText={feedback.type === 'STARTSITUATIE'}
      />
    );
  }

  renderFeedbackImageText = (feedback, overigEffect, economie, counter, forceEconomy = false) => {
    if(feedback.type === 'STARTSITUATIE') return [];
    const { gameState } = this.props;
    let text = getImageText(feedback, gameState.language);
    if (this.state.oe) {
      text = getImageText(overigEffect, gameState.language);
    }
    if (this.state.economie || forceEconomy) {
      text = getImageText(economie, gameState.language);
    }

    const elem = [];

    if(
        text &&
        text !== '<p>-</p>' &&
        text !== '<p>- </p>' &&
        text !== '<p> -</p>'
    ) {
      elem.push(
          <div key='opt1' className={`feedback-image-text ${counter % 2 === 0 ? 'left' : 'right'}`}>
            <span dangerouslySetInnerHTML={{__html: text}}/>
          </div>
      );
      if(counter % 2 === 0) {
        elem.push(<div key='opt2' className="feedback-image-text right"/>);
      } else {
        elem.unshift(<div key='opt3' className="feedback-image-text left"/>);
      }

      return elem;
    } else {
      if (feedback.niveau === 'Basic' && feedback.type === 'BELEIDSKEUZE') {
        elem.push(
          <div key="opt1" className="feedback-image-text left"><span/></div>
        );
        elem.push(
          <div key="opt2" className="feedback-image-text right"><span/></div>
        );
        return elem;
      }
    }
  }

  renderPolicyChoiceMade = (feedback, lang = 'NL') => {
    if (feedback.type === "BELEIDSKEUZE") {
      return (
        <div className="feedbackText">
          <ContentContainer className="grey standardAnimation">
            <div style={{display: 'block', width: '100%'}}>
              <h3>{__n('sim_beleidskeuze', 1)}: {feedback[`titel_beleidskeuze_${lang}`].toLowerCase()}</h3>
              <p>{feedback[`tekst_beleidskeuze_${lang}`]}</p>
            </div>
          </ContentContainer>
        </div>
      );
    }
    return null;
  }

  renderFeedbackText = (feedback, overigEffect, economie, forceEconomy = false) => {
    const { gameState, match: {params: {identifier}} } = this.props;
    let text = getText(feedback, gameState.language);
    if (this.state.oe) {
      text = getText(overigEffect, gameState.language)
    }
    if (this.state.economie || forceEconomy) {
      text = getText(economie, gameState.language)
    }

    return (<div className="feedbackText" id={feedback.omschrijving} ref={(feedback.omschrijving === identifier ? this.setScrollToRef : null)}>
      <ContentContainer className={'standardAnimation'}>
        <div dangerouslySetInnerHTML={{ __html: text }}/>
      </ContentContainer>
    </div>);
  }

  renderHoog() {
    const { match, gameState, feedback: {prevRoundFeedbackData} } = this.props;
    const feedback = getFeedback(prevRoundFeedbackData, this.state.feedbackId);
    if(Object.entries(feedback).length === 0 && feedback.constructor === Object) {
      let url = "/ministries/" + (match.params.ministryId !== undefined ? match.params.ministryId : match.params.id);
      history.push(url);
      return null;
    }

    const overigEffect = feedback.overigeEffecten[this.state.effectId] || {};
    const economie = feedback.economie || {};
    if (!economie) this.state.economie = false;
    if (!overigEffect) this.state.oe = false;
    // Check if OE
    if (this.state.oe || this.state.economie) feedback.type = 'OVERIGEFFECT'; // override type with OE
    if(!checkRead(feedback, this.state.oe, this.state.effectId, this.state.economie)) {
      if (this.state.oe) {
        feedback.read['readOe_' + this.state.effectId] = true;

        const array = feedback.read;

        array['readOe_' + this.state.effectId] = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else if (this.state.economie) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else {
        feedback.read.read = true;

        const array = feedback.read;

        this.props.dispatch(updateRead(feedback.id, array));
      }
    }

    const feedbackHeader = this.renderFeedbackHeader(feedback, overigEffect, economie);
    const statistics = this.renderStatistics(feedback, overigEffect, economie);
    const statusRounds = ['ALGEMEEN', 'RAMP', 'STARTSITUATIE'].indexOf(feedback.type) !== -1 ? <FeedbackStatusRounds desktop={true} ministry={feedback.ministerie}/> : null;
    const policyChoiceMade = this.renderPolicyChoiceMade(feedback, gameState.language);
    const feedbackImage = this.renderFeedbackImage(feedback, overigEffect, economie, policyChoiceMade);
    const feedbackText = this.renderFeedbackText(feedback, overigEffect, economie);
    let counter = 0;
    if(feedbackHeader) counter++;
    if(statistics) counter++;
    if(policyChoiceMade) counter++;
    if(statusRounds) counter++;
    if(feedbackImage) counter++;

    const feedbackImageText = this.renderFeedbackImageText(feedback, overigEffect, economie, (policyChoiceMade ? counter + 1 : counter));
    const feedbackType = feedback.type;
    return (
      <div className={'darkBckg'}  style={ {height: '100%'} }>
        <Scrollbar className="custom-height-step-3" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
          <div key="fbWrapper" className={`container feedbackcontainer ${feedback.nevenEffecten && !this.state.oe && !this.state.economie ? 'hasEffect--pro' : ''} ${feedback.type === 'STARTSITUATIE' ? 'isStartsituation' : ''}`}>
            {feedbackHeader}
            {statistics}
            {statusRounds}
            {policyChoiceMade}
            {policyChoiceMade ? (
              <Fragment>
                {feedbackText}
                {feedbackImage}
              </Fragment>
            ) : (
              <Fragment>
                {feedbackImage}
                {feedbackText}
              </Fragment>
            )}
            {(counter % 2 === 0 ? feedbackImageText : null)}
            {feedback.nevenEffecten && !this.state.oe && !this.state.economie ? (
              <div className={this.state.showEffects ? 'effects-container show' : 'effects-container'}>
                <div key="effectsHeader" className={'effects-header'} onClick={() => this.state.showEffects ? this.setState({showEffects: false}) : this.setState({showEffects: true})}>
                  <div className={'effectsTitle'}>
                    {feedback.type === 'BELEIDSKEUZE' ? __('sim_beleidskeuze_heeft_effect_op') : __('sim_budgetkeuze_heeft_effect_op')}:
                  </div>
                  <div className={'effectsIcons'}>
                    {feedback.overigeInkomsten ? <img src={(icons.gift)} alt={'gift'}/> : ''}
                    {getSideEffects(feedback).map((oe, i) => {
                      return (<img src={ministryIcons[oe.ministerie]} alt={'minIcon'} key={i}/>);
                    })}
                    {feedback.economie ? <img src={parseInt(feedback.economie.winstverliesglobas, 10) >= 0 ? icons.upGlobas : icons.minGlobas} alt={'economy'}/> : ''}
                  </div>
                  <div className={'dropdown-effects'}>
                    <img src={CaretDown} alt={'caret'}/>
                  </div>
                </div>
                {/* Print OE */}
                {getSideEffects(feedback).map((oe, i) => {
                  return (
                    <FeedbackEffect
                      className={feedbackType}
                      key={i}
                      image={getImage(oe)}
                      // minimal={minimal}
                      ministry={__(oe.ministerie)}
                      ministryIcon={ministryIcons[oe.ministerie]}
                      description={getImageText(oe, gameState.language)}
                      unit={__('sim_punten').toLowerCase()}
                      points={getPoints(oe, gameState)}>
                      <div dangerouslySetInnerHTML={{ __html: getText(oe, gameState.language) }}/>
                    </FeedbackEffect>
                  );
                })}
                {/* Print Economie */}
                {feedback.economie ? (
                  <FeedbackEffect
                    className={feedbackType}
                    image={getImage(feedback.economie)}
                    ministry={__('sim_economie')}
                    pointsTitle={`${Math.abs(feedback.economie.winstverliesglobas)} ${__('sim_miljard')} ${parseInt(feedback.economie.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas')}`}
                    ministryIcon={parseInt(feedback.economie.winstverliesglobas, 10) >= 0 ? icons.upGlobas : icons.minGlobas}
                    description={getImageText(feedback.economie, gameState.language)}
                    unit={__('sim_globas')}
                    points={feedback.economie.winstverliesglobas}>
                    <div dangerouslySetInnerHTML={{ __html: getText(feedback.economie, gameState.language) }}/>
                  </FeedbackEffect>
                ) : null}
                {/* Print OI */}
                {feedback.overigeInkomsten ? (
                  <FeedbackEffect
                    className={feedbackType}
                    image={getImage(feedback.economie)}
                    ministry={__('sim_overige_inkomsten')}
                    ministryIcon={icons.gift}
                    pointsTitle={`${feedback.overigeInkomsten.winstverliesglobas} ${__('sim_miljard')} ${__('sim_globas')}`}
                    description={getImageText(feedback.overigeInkomsten, gameState.language)}
                    unit={__('sim_globas')}
                    points={feedback.overigeInkomsten.winstverliesglobas}>
                    <div dangerouslySetInnerHTML={{ __html: getText(feedback.overigeInkomsten, gameState.language) }}/>
                  </FeedbackEffect>
                ) : null}
              </div>
            ) : null}
          </div>
        </Scrollbar>
        <NextStep/>
      </div>
    );
  }

  getFeedbackEffectLaag = (oi, e, f) => {
    let icon,
        text,
        type,
        clickable;
    if (e) {
      clickable = true;
      icon = e.winstverliesglobas >= 0 ? icons.thumbsUp : icons.thumbsDown;
      text = e.winstverliesglobas >= 0
        ? __('sim_feedback_door_keuze_meer_globas')
        : __('sim_feedback_door_keuze_minder_globas');

      type = e.winstverliesglobas >= 0 ? 'profit' : 'loss';
    } else if (oi) {
      clickable = false;
      // OI is altijd positief
      icon = icons.thumbsUp;
      text = __('sim_feedback_keuze_extra_inkomsten');
    }

    const url = `/ministries/overview/basic/${type}/${f.omschrijving}`;

    if (e || oi) {
      return <div className="feedback-laag-oi">
        <img src={icon} alt="thumbs" />
        <Link to={url} style={clickable ? {} : { pointerEvents: 'none' }}>
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </Link>
      </div>;
    }
    return null;
  }

  generateLowInnerFeedback = (feedback, counter) => {
    const economie = feedback.economie;

    let eco = false;
    if (economie || this.state.economie) {
      eco = true;
    }

    // Check if OE
    if (this.state.oe || this.state.economie) feedback.type = 'OVERIGEFFECT'; // override type with OE

    if(!checkRead(feedback, this.state.oe, this.state.effectId, eco)) {
      if (this.state.oe) {
        feedback.read['readOe_' + this.state.effectId] = true;

        const array = feedback.read;

        array['readOe_' + this.state.effectId] = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else if (eco) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else {
        feedback.read.read = true;

        const array = feedback.read;

        this.props.dispatch(updateRead(feedback.id, array));
      }
    }

    const feedbackImageText = this.renderFeedbackImageText(feedback, false, economie, counter + 1, eco);
    return (
      <div key={feedback.id} className={this.state.pageType === 'beleidskeuze' ? 'container feedbackcontainer feedbackcontainer-collection beleidskeuze-low' : 'container feedbackcontainer feedbackcontainer-collection'}>
        {this.renderFeedbackHeader(feedback, false, economie, (counter > 1), true)}
        {counter % 2 !== 0 ? this.renderFeedbackImage(feedback, undefined, economie, eco) : this.renderFeedbackText(feedback, undefined, economie, eco)}
        {counter % 2 === 0 ? this.renderFeedbackImage(feedback, undefined, economie, eco) : this.renderFeedbackText(feedback, undefined, economie, eco)}
        {feedbackImageText}
      </div>
    );
  }

  renderLaag() {
    const { match, feedback: {prevRoundFeedbackData} } = this.props;
    const feedback = getFeedback(prevRoundFeedbackData, this.state.feedbackId);
    if(match.path === '/ministries/overview/basic/:type/:identifier?'){
      const feedback = getEconomieFeedback(prevRoundFeedbackData, match.params.type);
      let counter = 0;
      const entries = feedback.map((current) => {counter++; return this.generateLowInnerFeedback(current, counter);});

      if(!counter) {
        this.props.history.push("/economy/total");
      }

      return (
        <div className={'darkBckg'}>
          <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
            {entries}
          </Scrollbar>
          <NextStep/>
        </div>
      )
    }

    if(Object.entries(feedback).length === 0 && feedback.constructor === Object) {
      let url = "/ministries/" + (match.params.ministryId !== undefined ? match.params.ministryId : match.params.id);
      history.push(url);
      return null;
    }

    const overigEffect = feedback.overigeEffecten[this.state.effectId];
    const economie = feedback.economie;
    if (!economie) this.state.economie = false;
    if (!overigEffect) this.state.oe = false;
    // Check if OE
    if (this.state.oe || this.state.economie) feedback.type = 'OVERIGEFFECT'; // override type with OE
    if(!checkRead(feedback, this.state.oe, this.state.effectId, this.state.economie)) {
      if (this.state.oe) {

        feedback.read['readOe_' + this.state.effectId] = true;

        const array = feedback.read;

        array['readOe_' + this.state.effectId] = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else if (this.state.economie) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else {
        feedback.read.read = true;

        const array = feedback.read;

        this.props.dispatch(updateRead(feedback.id, array));
      }
    }

    const feedbackHeader = this.renderFeedbackHeader(feedback, overigEffect, economie);
    const statistics = this.renderStatistics(feedback, overigEffect, economie);
    const statusRounds = ['ALGEMEEN', 'RAMP', 'STARTSITUATIE'].indexOf(feedback.type) !== -1 ? <FeedbackStatusRounds desktop={true} ministry={feedback.ministerie}/> : null;
    const feedbackImage = this.renderFeedbackImage(feedback, overigEffect, economie);
    const feedbackText = this.renderFeedbackText(feedback, overigEffect, economie);

    let counter = 0;
    if(feedbackHeader) counter++;
    if(statistics) counter++;
    if(statistics && this.state.pageType === 'beleidskeuze') counter++;
    if(statusRounds) counter++;
    if(feedbackImage) counter++;

    const feedbackImageText = this.renderFeedbackImageText(feedback, overigEffect, economie, counter);

    return (
      <div className={'darkBckg'}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
          <div key="fbWrapper" className={`container feedbackcontainer ${this.state.pageType === 'beleidskeuze' ? 'beleidskeuze-low' : ''} ${feedback.overigeInkomsten || feedback.economie ? 'hasEffect--basic' : ''} ${feedback.type === 'STARTSITUATIE' ? 'isStartsituation' : ''}`}>
            {feedbackHeader}
            {statistics}
            {statusRounds}
            {feedbackImage}
            {(counter % 2 !== 0 ? feedbackImageText : null)}
            {feedbackText}
            {(counter % 2 === 0 ? feedbackImageText : null)}

            {feedback.overigeInkomsten || feedback.economie ? (
              <div className={'effects-container laag'}>
                <div key="effectsHeader" className={'effects-header'}>
                  <div className={'effects-header-inner'}>
                    <img src={icons.megafoon} alt="megafoon" />
                    <span>{__('sim_let_op')}</span>
                  </div>
                </div>
                <FeedbackEffect minimal={true} difficulty="BASIC">
                  {this.getFeedbackEffectLaag(feedback.overigeInkomsten, feedback.economie, feedback)}
                </FeedbackEffect>
              </div>
            ) : null}
          </div>
        </Scrollbar>
        <NextStep/>
      </div>
    );
  }
}

export default connect(({gameState, feedback, project, gameStateInput, schoolClass}) => ({gameState, feedback, project, gameStateInput, schoolClass}))(Feedback);



// WEBPACK FOOTER //
// ./src/components/desktop/Feedback.js